import config from '@config/index';

/**
 * Only urls matching one of the configured prefixes are honoured, so that the payment success page cannot be turned
 * into an open redirect by crafting a link.
 */
export function sanitizeReturnUrl(returnUrl: string | null): string | null {
  if (!returnUrl) {
    return null;
  }

  const prefixes = (config.VITE_APP_RETURN_URL_ALLOWED_PREFIXES ?? '')
    .split(',')
    .map(prefix => prefix.trim())
    .filter(prefix => prefix.length > 0);

  return prefixes.some(prefix => returnUrl.startsWith(prefix)) ? returnUrl : null;
}
